/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

import moduleEditor from "./editor/moduleEditor.js";
import moduleAuth from "./auth/moduleAuth.js";
import moduleSocialAuth from "./socialAuth/moduleSocialAuth.js";
import moduleUsers from "./users/moduleUsers.js";
import moduleOrganization from "./organization/moduleOrganization.js";
import moduleParser from "./parser/moduleParser.js";

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    editor: moduleEditor,
    auth: moduleAuth,
    socialAuth: moduleSocialAuth,
    users: moduleUsers,
    organization: moduleOrganization,
    parser: moduleParser,
  },
  strict: process.env.NODE_ENV !== "production",
});
